export const LINE1 =
  'You will have received an email from Kanda containing details on how to claim your new dashboard.';

export const LINE2 =
  "If you can't find the email, please check your spam folder, or click the button below to contact Kanda and we'll help get you sorted";

export const MESSAGE =
  "I can't find my new account email. My enterprise ID is $id. Could you provide help with setting up my new account.";
